export default __webpack_public_path__ + "static/media/Capure.f81087e6.png";